import { Button as AntButton, message } from 'antd'
import React, { useState } from 'react'
import { dismissCensusUploadJob } from '../api/census-enrollment-platform-api-client'
import { CensusUploadJobDto } from '../api/dto/census-upload-job.dto'

// Only a failed upload can be dismissed
function CensusQueueActionsCell({
  job,
  onChanged,
}: {
  job: CensusUploadJobDto
  onChanged: () => void
}) {
  const [isDismissing, setIsDismissing] = useState(false)

  if (job.status !== 'FAILED') {
    return null
  }

  const dismiss = async () => {
    setIsDismissing(true)
    try {
      await dismissCensusUploadJob(job.id)
      message.success('The upload was dismissed.')
    } catch (error) {
      const reason = (error as any)?.response?.data?.message ?? error
      message.error(`Could not dismiss the upload. ${reason}`)
    }
    setIsDismissing(false)
    // Refresh either way: a 409 means the row is no longer failed
    onChanged()
  }

  return (
    <AntButton onClick={dismiss} loading={isDismissing}>
      Dismiss
    </AntButton>
  )
}

export default CensusQueueActionsCell
